// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export { LivePageComponentServer } from './LivePageComponentServer';

export const LivePageComponentLoader = LoadablePaint({
	name: MustPreloadLoadableNames.LivePageComponentLoader,
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-LivePageComponent" */ '../src/LivePageComponent'))
			.LivePageComponent,
});
